export const UNSAVED_CHANGES_KEY = 'recon.unsavedChanges';
// Managed drafts own their baseline and accessible confirmation. Legacy forms
// keep their existing storage flag until they adopt an owned guard.
const draftGuards = new Set();
export const registerDraftGuard = guard => {
  draftGuards.add(guard);
  return () => draftGuards.delete(guard);
};
const dirtyDraft = () => [...draftGuards].find(guard => guard.isDirty());
export const hasManagedUnsavedChanges = () => Boolean(dirtyDraft());

export const markUnsavedChanges = () => {
  try { window.sessionStorage.setItem(UNSAVED_CHANGES_KEY, '1'); } catch { /* storage may be unavailable */ }
};

export const clearUnsavedChanges = () => {
  try { window.sessionStorage.removeItem(UNSAVED_CHANGES_KEY); } catch { /* storage may be unavailable */ }
};

export const hasUnsavedChanges = () => {
  if (dirtyDraft()) return true;
  try { return window.sessionStorage.getItem(UNSAVED_CHANGES_KEY) === '1'; } catch { return false; }
};

export const confirmDiscardUnsavedChanges = onDiscard => {
  const guard = dirtyDraft();
  if (guard) {
    guard.confirm().then(approved => { if (approved) onDiscard?.(); });
    return false;
  }
  if (!hasUnsavedChanges()) return true;
  const approved = window.confirm('You will lose the entered data. Do you still want to continue?');
  if (approved) clearUnsavedChanges();
  return approved;
};

export const requestDiscardUnsavedChanges = async () => {
  const guard = dirtyDraft();
  return guard ? guard.confirm() : confirmDiscardUnsavedChanges();
};

export const protectUnsavedChangesBeforeUnload = event => {
  if (!hasUnsavedChanges()) return;
  event.preventDefault();
  event.returnValue = 'You have unsaved changes.';
};
